import { Pipe, PipeTransform } from '@angular/core';
import { RemoveZerosRight } from '@libs/helper/wallet/wallet.helper';
import { IWallet } from '@libs/interfaces';
import { head, last } from 'lodash';
@Pipe({ name: 'cryptoBalance' })
export class CryptoBalancePipe implements PipeTransform {
  transform(balance: number, currency: IWallet): string {
    if (!currency) return '0';
    const value = (balance / +currency.metric).toFixed(currency.decimals);
    const splitted = value.split('.');
    return `${head(splitted)}.${RemoveZerosRight(last(splitted))}`;
  }
}
